export default function relocalizeUrl(url, destLang) {
  const delang = url
    .replace(`/${process.env.CI_COMMIT_REF_NAME}`, "")
    .split("/")
    .slice(4);
  return "/" + [destLang, ...delang].join("/");
}
